import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const RydMarketingOverview = () =>
  import('@/pages/ryd-marketing/overview/RydMarketingOverview.vue');
const AddDynamicParameters = () =>
  import('@/pages/ryd-marketing/deeplinking/add-dynamic-parameters/AddDynamicParameters.vue');
const CdnManagement = () =>
  import('@/pages/ryd-marketing/cdn-management/cdn-file-management/CdnManagement.vue');
const PartnerLinks = () =>
  import('@/pages/ryd-marketing/homepage/partner-affiliate-links/PartnerLinks.vue');
const AwinPushNotifications = () =>
  import('@/pages/ryd-marketing/homepage/awin-pushes/AwinPushNotifications.vue');
const MandrillTemplates = () =>
  import('@/pages/ryd-marketing/mandrill-templates/template-browser/MandrillTemplates.vue');
const MandrillTemplateUsageAnalytics = () =>
  import('@/pages/ryd-marketing/mandrill-templates/template-usage-analytics/MandrillTemplateUsageAnalytics.vue');
const MailchimpAudienceExport = () =>
  import('@/pages/ryd-marketing/mailchimp-audience-export/MailchimpAudienceExport.vue');
const MailchimpAudienceExportKnowledgeBase = () =>
  import('@/pages/ryd-marketing/mailchimp-audience-export/MailchimpAudienceExportKnowledgeBase.vue');
const PitchBuilderPage = () => import('@/pages/ryd-marketing/pitch-builder/PitchBuilderPage.vue');
const PitchBuilderKnowledgeBase = () =>
  import('@/pages/ryd-marketing/pitch-builder/PitchBuilderKnowledgeBase.vue');
const PitchBuilderSavedList = () =>
  import('@/pages/ryd-marketing/pitch-builder/saved/PitchBuilderSavedList.vue');
const PitchBuilderMetadataAdmin = () =>
  import('@/pages/ryd-marketing/pitch-builder/admin/PitchBuilderMetadataAdmin.vue');

export const rydMarketingRoutes: AppRouteRecordRaw[] = [
  {
    path: '/ryd-marketing',
    component: Body,
    meta: {
      requiresAuth: true,
      requiredUserGroup: ['ryd'],
      breadcrumb: 'RYD Marketing',
    },
    children: [
      {
        path: 'overview',
        name: 'rydMarketingOverview',
        component: RydMarketingOverview,
        meta: {
          title: 'ryd Marketing Overview | ryd Portal',
          breadcrumb: 'Overview',
        },
      },
      {
        path: 'deeplinking/add-dynamic-parameters',
        name: 'AddDynamicParameters',
        component: AddDynamicParameters,
        meta: {
          title: 'Add Dynamic Parameters | ryd Portal',
          breadcrumb: 'Add Dynamic Parameters',
        },
      },
      {
        path: 'cdn-management/cdn-file-management',
        name: 'CdnManagement',
        component: CdnManagement,
        meta: {
          title: 'CDN Management | ryd Portal',
          breadcrumb: 'CDN Management',
        },
      },
      {
        path: 'homepage/partner-affiliate-links',
        name: 'homepage-partner-affiliate-links',
        component: PartnerLinks,
        meta: {
          title: 'Homepage Partner Affiliate Links | ryd Portal',
          breadcrumb: 'Homepage Partner Links',
        },
      },
      {
        path: 'homepage/awin-pushes',
        name: 'awin-push-notifications',
        component: AwinPushNotifications,
        meta: {
          title: 'Awin Push Notifications | ryd Portal',
          breadcrumb: 'Awin Push Notifications',
        },
      },
      {
        path: 'mandrill-templates/template-browser',
        name: 'ryd-marketing-mandrill-templates',
        component: MandrillTemplates,
        meta: {
          title: 'Mandrill Templates | ryd Portal',
          breadcrumb: 'Mandrill Templates',
        },
      },
      {
        path: 'mandrill-templates/template-usage-analytics',
        name: 'ryd-marketing-mandrill-template-usage',
        component: MandrillTemplateUsageAnalytics,
        meta: {
          title: 'Mandrill template usage | ryd Portal',
          breadcrumb: 'Template usage analytics',
        },
      },
      {
        path: 'mailchimp-audience-export',
        name: 'mailchimpAudienceExport',
        component: MailchimpAudienceExport,
        meta: {
          title: 'Mailchimp Audience Export | ryd Portal',
          headTitle: 'Mailchimp Audience Export',
          requiredUserGroup: ['ryd'],
          breadcrumb: 'Mailchimp Audience Export',
        },
      },
      {
        path: 'mailchimp-audience-export/knowledge-base',
        name: 'mailchimpAudienceExportKnowledgeBase',
        component: MailchimpAudienceExportKnowledgeBase,
        meta: {
          title: 'Mailchimp Audience Export Knowledge Base | ryd Portal',
          breadcrumb: 'Mailchimp Audience Export Knowledge Base',
        },
      },
      {
        path: 'pitch-builder',
        name: 'pitchBuilder',
        component: PitchBuilderPage,
        meta: {
          title: 'Pitch Builder | ryd Portal',
          breadcrumb: 'Pitch Builder',
        },
      },
      {
        path: 'pitch-builder/saved',
        name: 'pitchBuilderSavedList',
        component: PitchBuilderSavedList,
        meta: {
          title: 'Saved Pitches | ryd Portal',
          breadcrumb: 'Saved Pitches',
        },
      },
      {
        path: 'pitch-builder/knowledge-base',
        name: 'pitchBuilderKnowledgeBase',
        component: PitchBuilderKnowledgeBase,
        meta: {
          title: 'Pitch Builder Knowledge Base | ryd Portal',
          breadcrumb: 'Pitch Builder Knowledge Base',
        },
      },
      {
        path: 'pitch-builder/admin',
        name: 'pitchBuilderMetadataAdmin',
        component: PitchBuilderMetadataAdmin,
        meta: {
          title: 'Pitch Builder Metadata | ryd Portal',
          breadcrumb: 'Pitch Builder Metadata',
        },
      },
    ],
  },
];
